var exports = {
  "B": "transparencyDataTable__4egxVf",
};

module.exports = exports;
